import { Theme } from "@bluframe/blublocks"
import Typography from "components/Typography"
import styled from "styled-components"

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  column-gap: 5px;
`

export const LoadingWrapper = styled.div`
  margin-right: 5px;
`

export const Paragraph = styled(Typography.Paragraph)`
  color: ${({ theme }: { theme: Theme }) => theme.palette.subtitle.main};
  font-size: 16px;
  font-weight: 400;
  margin: 0;
`
